module.exports = __webpack_public_path__ + "img/SmartphoneEarbuds.c28959ab.png";